(() => {
	let showTriggerAnimation = true;
	let allowSwiperMove = true;
	
	window.addEventListener("DOMContentLoaded", initializeCollectionSlider);
	window.addEventListener("resize", initializeCollectionSlider);
  
	function initializeCollectionSlider() {
	  if (!window.matchMedia("(max-width: 767px)").matches) return;
  
	  const sliders = document.querySelectorAll(".product-item__image-wrapper .swiper.only-mobile");
	  lazyLoadAnimation();
  
	  sliders.forEach((slider) => {
		if (slider.classList.contains("swiper-initialized")) return;
  
		const swiper = new Swiper(slider, {
			speed: 300,
			slidesPerView: 1,
			preloadImages: true,
			lazy: false,
			allowTouchMove: allowSwiperMove,
			on: {
			  init: () => {
				if (showTriggerAnimation) {
				  triggerFirstSlider(slider);
				  showTriggerAnimation = false;
				}
			  },
			},
		  });
	  });
	}

	function lazyLoadAnimation() {
	  document
		.querySelectorAll(".product-item__image-wrapper .swiper.only-mobile img")
		.forEach((img) => {
		  if (img.complete) {
			img.classList.add("loaded");
		  } else {
			img.addEventListener("load", () => img.classList.add("loaded"));
		  }
		});
	}
  
	function triggerFirstSlider(slider) {
	  const wrapper = slider.querySelector(".swiper-slide.swiper-slide-active");
	  if (!wrapper) return;
  
	  wrapper.style.transition = "transform 0.5s ease-out";
	  
	  const initialDelay = 1000; // Pause vor der ersten Animation in ms
	  const animationDuration = 1000; // Dauer einer Animation in ms
	  const pauseBetweenAnimations = 500; // Pause zwischen Animationen in ms
	  const totalCycleTime = animationDuration + pauseBetweenAnimations;
	  
	  for (let i = 0; i < 2; i++) {
		const startTime = initialDelay + (i * totalCycleTime);
		
		// Animation starten: nach links bewegen
		setTimeout(() => {
		  wrapper.style.transform = "translate3d(-35%, 0, 0)";
		}, startTime);
		
		// Animation zurücksetzen: zurück zur Ausgangsposition
		setTimeout(() => {
		  wrapper.style.transform = "translate3d(0, 0, 0)";
		}, startTime + animationDuration);
	  }
	}
  })();
